import githubLogo from '../../resources/github.svg';
import goodreadsLogo from '../../resources/goodreads.svg';
import hnLogo from '../../resources/hackernews.svg';
import linkedinLogo from '../../resources/linkedin.svg';
import lobstersLogo from '../../resources/lobsters.svg';
import osnewsLogo from '../../resources/osnews.png';
import redditLogo from '../../resources/reddit.svg';
import slashdotLogo from '../../resources/slashdot.svg';
import tedLogo from '../../resources/ted.svg';
import twitterLogo from '../../resources/twitter.svg';
import wikipediaLogo from '../../resources/wikipedia.svg';
import xLogo from '../../resources/x.svg';
import youtubeLogo from '../../resources/youtube.svg';

// Every brand recognized by the client: its artwork, the domains, and the color
// (if brand backs a source).
const BRANDS = {
  github: { logo: githubLogo, domains: ['github.com'], color: '#24292f' },
  goodreads: { logo: goodreadsLogo, domains: ['goodreads.com'] },
  hackernews: { logo: hnLogo, domains: ['ycombinator.com'], color: '#ff6600' },
  linkedin: { logo: linkedinLogo, domains: ['linkedin.com'] },
  lobsters: { logo: lobstersLogo, domains: ['lobste.rs'], color: '#ac130d' },
  osnews: { logo: osnewsLogo, domains: ['osnews.com'] },
  reddit: { logo: redditLogo, domains: ['reddit.com'], color: '#ff4500' },
  slashdot: { logo: slashdotLogo, domains: ['slashdot.org'] },
  ted: { logo: tedLogo, domains: ['ted.com'] },
  twitter: { logo: twitterLogo, domains: ['twitter.com'] },
  wikipedia: { logo: wikipediaLogo, domains: ['wikipedia.org'] },
  x: { logo: xLogo, domains: ['x.com'], color: '#000000' },
  youtube: { logo: youtubeLogo, domains: ['youtube.com'], color: '#ff0000' },
};

// Domain to brand.
const BRAND_BY_DOMAIN = {};
Object.entries(BRANDS).forEach(([brand, { domains }]) => {
  (domains || []).forEach((domain) => { BRAND_BY_DOMAIN[domain] = brand; });
});

/**
 * The brand a host belongs to (`news.ycombinator.com` is `hackernews`), or
 * null. Subdomains count, neighbours don't: `linux.com` is not `x.com`.
 */
export function domainBrand(domain) {
  const labels = (domain || '').toLowerCase().split('.');
  for (let i = 0; i < labels.length; i += 1) {
    const brand = BRAND_BY_DOMAIN[labels.slice(i).join('.')];
    if (brand) return brand;
  }
  return null;
}

// A link with no brand behind it.
export const UNBRANDED_COLOR = '#fff';
export const UNBRANDED_BG = '#3c3c3c';

// Artwork for a brand, or null when we carry none for it.
export function brandLogo(brand) {
  return (BRANDS[brand] && BRANDS[brand].logo) || null;
}

// The brand's own color, or null.
export function brandColor(brand) {
  return (BRANDS[brand] && BRANDS[brand].color) || null;
}

/**
 * Artwork for a link's host, or null.
 */
export function domainLogo(domain) {
  return brandLogo(domainBrand(domain));
}
